module.exports = __webpack_public_path__ + "static/Pt13-2a81dc9584d38d73f954daca6118a86e.jpg";